import { desformatarNumero, desformatarNumero_5D_calculos } from "../../Func_genericas/formatar_numero_formato_pt";

// DIVISÃO ENTRE DOIS NUMEROS
export const resultado_divisao_dois_numeros = (campo_dividir_pela_area: number | undefined, area_value: number | undefined) => {
    const result = area_value !== 0 && area_value !== undefined && campo_dividir_pela_area !== 0 && campo_dividir_pela_area !== undefined
        ? (campo_dividir_pela_area / area_value)
        : 0;
    return isNaN(result) ? 0 : result
}
export const format_strings_to_numbers = (value: string, flag_usar_em_calculos: boolean = true) => {

    let aux_value_array = value.split(',')
    if (flag_usar_em_calculos === true) {


      let aux_value = aux_value_array.length === 1 ? value :
        aux_value_array[1].length === 0 ? value.replace(",", ".") :
          aux_value_array[1].length === 1 ?
            aux_value_array[0] + '.' + aux_value_array[1] + '0' :
            value.replace(",", ".")

      return Number(aux_value)
    } else {
      let aux_value = aux_value_array.length === 1 ? value :
        aux_value_array[1].length === 0 ? value.replace(",", ".") :
          aux_value_array[1].length === 1 ?
            aux_value_array[0] + '.' + aux_value_array[1] :
            value.replace(",", ".")
      return aux_value

    }

  }


// MULTIPLICAÇÃO ENTRE DOIS NUMEROS
export const resultado_multiplicação_dois_numeros = (campo_um: number | undefined, campo_dois: number | undefined) => {
    const result = campo_um !== 0 && campo_um !== undefined && campo_dois !== 0 && campo_dois !== undefined
        ? (campo_um * campo_dois)
        : 0;
    return isNaN(result) ? 0 : result
}

// MULTIPLICAÇÃO ENTRE TRES NUMEROS
export const resultado_multiplicação_tres_numeros = (campo_um: number | undefined, campo_dois: number | undefined, campo_tres: number | undefined) => {
    const result = campo_um !== 0 && campo_um !== undefined && campo_dois !== 0 && campo_dois !== undefined && campo_tres !== 0 && campo_tres !== undefined
        ? (campo_um * campo_dois * campo_tres)
        : 0;
    return isNaN(result) ? 0 : result
}

/*********************** SOMAS DE LISTA  *****************/
export const somaTotal = (rows: any, field: any) => {
    return rows.reduce((acc: number, row: any) => {
        const valor = desformatarNumero(row[field]);
        return isNaN(valor) ? acc : acc + valor;
    }, 0);
};

export const somaQuatroCampos = (campo1: number | undefined, campo2: number | undefined, camp3: number | undefined, camp4: number | undefined) => {

    const resultado = campo1 !== undefined &&
        campo2 !== undefined &&
        camp3 !== undefined &&
        camp4 !== undefined ?
        campo1 + campo2 + camp3 + camp4 : 0;

    return isNaN(resultado) ? 0 : resultado;
};

export const somaOitoCampos = (
    campo1: number | undefined,
    campo2: number | undefined,
    camp3: number | undefined,
    camp4: number | undefined,
    camp5: number | undefined,
    camp6: number | undefined,
    camp7: number | undefined,
    camp8: number | undefined
) => {

    const resultado =
        campo1 !== undefined &&
            campo2 !== undefined &&
            camp3 !== undefined &&
            camp4 !== undefined &&
            camp5 !== undefined &&
            camp6 !== undefined &&
            camp7 !== undefined &&
            camp8 !== undefined
            ?
            campo1 + campo2 + camp3 + camp4 + camp5 + camp6 + camp7 + camp8 : 0;

    return isNaN(resultado) ? 0 : resultado;
};


/*********************** SOMAS / TOTAIS Página 5D Azoto Cadernos ****************/
//((valor_1 * 1000000) / 100) Quadro Azoto cadernos 5D
export const val_total_Quant_dois_5D = (teorn: number | undefined) => {
    return teorn !== 0 && teorn !== undefined
        ? (teorn * 1000000 / 100)
        : 0;
}
// Valor campo quantidade tres Quadro Azoto cadernos 5D
export const resultado_Quant_tres = (valor_quant_2: number | undefined, quantidadeum: number | undefined) => {
    return valor_quant_2 !== 0 && valor_quant_2 !== undefined && quantidadeum !== 0 && quantidadeum !== undefined
        ? (valor_quant_2 * 0.000001 * quantidadeum)
        : 0;
}
// Valor do campo quantidade quatro Quadro Azoto cadernos 5D
export const resultadoQuantQuatro = (quantidadeum: number | undefined, area_cabecalho: number | undefined) => {
    return quantidadeum !== 0 && quantidadeum !== undefined && area_cabecalho !== 0 && area_cabecalho !== undefined
        ? (quantidadeum * area_cabecalho)
        : 0;
}
// Valor do campo quantidade cinco Quadro Azoto cadernos 5D
export const resultadoQuantCinco = (valor_quantidade_3: number | undefined, area_cabecalho: number | undefined) => {
    return valor_quantidade_3 !== 0 && valor_quantidade_3 !== undefined && area_cabecalho !== 0 && area_cabecalho !== undefined
        ? (valor_quantidade_3 * area_cabecalho)
        : 0;
}
// Somas
export const somaQuantidadeQuatro = (rowsAzoto: any) => {
    return rowsAzoto.reduce((acc: any, row: any) => {
        const valor = desformatarNumero_5D_calculos(row.quantidade_quatro);
        return isNaN(valor) ? acc : acc + valor;
    }, 0);
};
export const somaQuantidadeCinco = (rowsAzoto: any) => {
    return rowsAzoto.reduce((acc: any, row: any) => {
        const valor = desformatarNumero_5D_calculos(row.quantidade_cinco);
        return isNaN(valor) ? acc : acc + valor;
    }, 0)
}
export const somaQuantidadeDois = (rowsAzoto: any) => {
    return (somaQuantidadeCinco(rowsAzoto) * 1000000 / somaQuantidadeQuatro(rowsAzoto)) || 0;
}
export const somaQuantidadeTres = (area_cab: any, rowsAzoto: any) => {
    const area = area_cab ? desformatarNumero_5D_calculos(area_cab) : 0;
    return area === 0 ? 0 : somaQuantidadeCinco(rowsAzoto) / area;
};




/************** EFICIENCIA ALIMENTAR *****************/
// Tabela Produção Forrageira página 2
export const somaCampoHA = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.ha_culturas) +
        getNumero(tabela?.ha_outras) +
        getNumero(tabela?.ha_pastagem) +
        getNumero(tabela?.ha_regadio) +
        getNumero(tabela?.ha_sequeiro) +
        getNumero(tabela?.ha_silagem);

    return resultado;
};
export const somaCampoTon = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.ma_culturas) +
        getNumero(tabela?.ma_outras) +
        getNumero(tabela?.ma_pastagem) +
        getNumero(tabela?.ma_regadio) +
        getNumero(tabela?.ma_sequeiro) +
        getNumero(tabela?.ma_silagem);

    return resultado;
};

// TABELA EFETIVO PECUARIO - 2.1
// Multiplicações
export const resultado_multiplicação_por04 = (campo_um: number | undefined) => {
    const result = campo_um !== 0 && campo_um !== undefined
        ? (campo_um * 0.4)
        : 0;
    return isNaN(result) ? 0 : result
}
export const resultado_multiplicação_por06 = (campo_um: number | undefined) => {
    const result = campo_um !== 0 && campo_um !== undefined
        ? (campo_um * 0.6)
        : 0;
    return isNaN(result) ? 0 : result
}


//TOTAIS DA TABELA EFETIVO PECUARIO
export const somaCampoAnimais = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.camp_1_animais) +
        getNumero(tabela?.camp_2_animais) +
        getNumero(tabela?.camp_3_animais) +
        getNumero(tabela?.camp_4_animais) +
        getNumero(tabela?.camp_5_animais) +
        getNumero(tabela?.camp_6_animais) +
        getNumero(tabela?.camp_7_animais) +
        getNumero(tabela?.camp_8_animais)

    return resultado;
};
export const somaCampoCN = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.camp_1_cn) +
        getNumero(tabela?.camp_2_cn) +
        getNumero(tabela?.camp_3_cn) +
        getNumero(tabela?.camp_4_cn) +
        getNumero(tabela?.camp_5_cn) +
        getNumero(tabela?.camp_6_cn) +
        getNumero(tabela?.camp_7_cn) +
        getNumero(tabela?.camp_8_cn)

    return resultado;
};


// Verificação existencia de x
export const verify_x = (
    value1: string | undefined,
    value2: string | undefined,
    value3: string | undefined,
    value4: string | undefined,
    value5: string | undefined,
    value6: string | undefined,
    value7: string | undefined,
    value8: string | undefined,
) => {
    const resultado = value1 !== undefined && value2 !== undefined && value3 !== undefined && value4 !== undefined && value5 !== undefined &&
        value6 !== undefined && value7 !== undefined && value8 !== undefined  ?
        (value1 === "x" || value2 === "x" ||
            value3 === "x" || value4 === "x" ||
            value5 === "x" || value6 === "x" ||
            value7 === "x" || value8 === "x" ? "x" : "") : "";

    return resultado;
}


export const somaCamposMais6Meses = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.camp_3_alimento_composto) +
        getNumero(tabela?.camp_4_alimento_composto) +
        getNumero(tabela?.camp_5_alimento_composto) +
        getNumero(tabela?.camp_6_alimento_composto) +
        getNumero(tabela?.camp_7_alimento_composto) +
        getNumero(tabela?.camp_8_alimento_composto);

    return resultado;
};

// Tabela Balanço campos soma
export const somaTotalMsPastagem = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.alimentacao_janeiro_Pastagem) +
        getNumero(tabela?.alimentacao_Fevereiro_Pastagem) +
        getNumero(tabela?.alimentacao_Marco_Pastagem) +
        getNumero(tabela?.alimentacao_Abril_Pastagem) +
        getNumero(tabela?.alimentacao_Maio_Pastagem) +
        getNumero(tabela?.alimentacao_Junho_Pastagem) +
        getNumero(tabela?.alimentacao_Julho_Pastagem) +
        getNumero(tabela?.alimentacao_Agosto_Pastagem) +
        getNumero(tabela?.alimentacao_Setembro_Pastagem) +
        getNumero(tabela?.alimentacao_Outubro_Pastagem) +
        getNumero(tabela?.alimentacao_Novembro_Pastagem) +
        getNumero(tabela?.alimentacao_Dezembro_Pastagem) ;

    return resultado;
};

export const somaTotalMsSilagem = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.alimentacao_janeiro_Silagem) +
        getNumero(tabela?.alimentacao_Fevereiro_Silagem) +
        getNumero(tabela?.alimentacao_Marco_Pastagem) +
        getNumero(tabela?.alimentacao_Abril_Silagem) +
        getNumero(tabela?.alimentacao_Maio_Silagem) +
        getNumero(tabela?.alimentacao_Junho_Silagem) +
        getNumero(tabela?.alimentacao_Julho_Silagem) +
        getNumero(tabela?.alimentacao_Agosto_Silagem) +
        getNumero(tabela?.alimentacao_Setembro_Silagem) +
        getNumero(tabela?.alimentacao_Outubro_Silagem) +
        getNumero(tabela?.alimentacao_Novembro_Silagem) +
        getNumero(tabela?.alimentacao_Dezembro_Silagem) ;

    return resultado;
};

export const somaTotalMsOutraFerragem = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.alimentacao_janeiro_outra_forragem) +
        getNumero(tabela?.alimentacao_Fevereiro_outra_forragem) +
        getNumero(tabela?.alimentacao_Marco_outra_forragem) +
        getNumero(tabela?.alimentacao_Abril_outra_forragem) +
        getNumero(tabela?.alimentacao_Maio_outra_forragem) +
        getNumero(tabela?.alimentacao_Junho_outra_forragem) +
        getNumero(tabela?.alimentacao_Julho_outra_forragem) +
        getNumero(tabela?.alimentacao_Agosto_outra_forragem) +
        getNumero(tabela?.alimentacao_Setembro_outra_forragem) +
        getNumero(tabela?.alimentacao_Outubro_outra_forragem) +
        getNumero(tabela?.alimentacao_Novembro_outra_forragem) +
        getNumero(tabela?.alimentacao_Dezembro_outra_forragem) ;

    return resultado;
};

export const somaTotalMsComposto = (tabela: any): number => {
    if (!tabela) return 0;

    const getNumero = (campo: any): number => {
        const valor = desformatarNumero(campo);
        return isNaN(valor) ? 0 : valor;
    };

    const resultado =
        getNumero(tabela?.alimentacao_janeiro_composto) +
        getNumero(tabela?.alimentacao_Fevereiro_composto) +
        getNumero(tabela?.alimentacao_Marco_composto) +
        getNumero(tabela?.alimentacao_Abril_composto) +
        getNumero(tabela?.alimentacao_Maio_composto) +
        getNumero(tabela?.alimentacao_Junho_composto) +
        getNumero(tabela?.alimentacao_Julho_composto) +
        getNumero(tabela?.alimentacao_Agosto_composto) +
        getNumero(tabela?.alimentacao_Setembro_composto) +
        getNumero(tabela?.alimentacao_Outubro_composto) +
        getNumero(tabela?.alimentacao_Novembro_composto) +
        getNumero(tabela?.alimentacao_Dezembro_composto) ;

    return resultado;
};



